var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4929 8.00955H8.77835L8.98657 10.0127H17.2857C17.164 11.7675 16.796 15.4853 16.661 17.177L11.9996 18.4774V18.4813L11.9893 18.4862L7.32489 16.8596L7.00534 13.0175H9.29169L9.45353 15.0838L11.9935 16.0223H11.9996L14.5355 15.1209L14.7963 12.0159H6.90329C6.86515 11.6143 6.37448 6.39899 6.28892 6.00637H17.697C17.6331 6.66742 17.5681 7.3465 17.4929 8.00955ZM4.01068 2C3.41667 2 2.95077 2.50531 3.00417 3.09163L4.49579 19.4692C4.5344 19.8931 4.83903 20.2464 5.25541 20.3504L11.7403 21.9697C11.9037 22.0105 12.0749 22.0101 12.2381 21.9686L18.7468 20.3153C19.1612 20.21 19.4638 19.8576 19.5024 19.4354L20.9958 3.09193C21.0494 2.5055 20.5834 2 19.9893 2H4.01068Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.66368235cab69c9881789594c0405597.svg";
export { ForwardRef as ReactComponent };